import "core-js/modules/es6.string.small";
import "core-js/modules/es6.number.constructor";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import times from 'lodash/times';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

var Headings = function Headings() {
  return import('~/components/atoms/Editorial/Headings.vue');
};

export default {
  name: 'CollectionOlapic',
  components: {
    MdmModal: MdmModal,
    Headings: Headings
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentPayload: function currentPayload() {
      var _this = this;

      var _ref, _ref2, _ref3, _ref8, _ref9, _ref10, _ref11;

      return {
        background: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.background) != null ? _ref11.url : _ref11 : _ref11 : _ref11) || '',
        title: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.title) != null ? _ref10[0] : _ref10 : _ref10 : _ref10) || '',
        paragraph: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.paragraph) != null ? (_ref9 = _ref9[0]) != null ? _ref9.text : _ref9 : _ref9 : _ref9 : _ref9) || '',
        button: {
          text: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.button_text : _ref8 : _ref8) || ''
        },
        images: times(4, Number).map(function (i) {
          var _ref4, _ref5, _ref6, _ref7;

          return {
            small: formatPrismicImage((_ref7 = _this.payload) != null ? (_ref7 = _ref7.items) != null ? (_ref7 = _ref7[i]) != null ? (_ref7 = _ref7.image) != null ? (_ref7 = _ref7.small) != null ? _ref7.url : _ref7 : _ref7 : _ref7 : _ref7 : _ref7) || EMPTY_PIXEL,
            medium: formatPrismicImage((_ref6 = _this.payload) != null ? (_ref6 = _ref6.items) != null ? (_ref6 = _ref6[i]) != null ? (_ref6 = _ref6.image) != null ? (_ref6 = _ref6.medium) != null ? _ref6.url : _ref6 : _ref6 : _ref6 : _ref6 : _ref6) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref5 = _this.payload) != null ? (_ref5 = _ref5.items) != null ? (_ref5 = _ref5[i]) != null ? (_ref5 = _ref5.image) != null ? (_ref5 = _ref5.large) != null ? _ref5.url : _ref5 : _ref5 : _ref5 : _ref5 : _ref5) || EMPTY_PIXEL,
            alt: ((_ref4 = _this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.alt : _ref4 : _ref4) || ''
          };
        }),
        tracking: {
          data: {
            event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
            event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
            event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
          }
        }
      };
    }
  }),
  methods: {
    closeAction: function closeAction() {
      this.showModal = false;
    },
    sharePhoto: function sharePhoto() {
      this.showModal = true;
    }
  }
};